module.exports = __webpack_public_path__ + "static/media/footer_desktop@1x.5d2f5c47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planning/footer_desktop@1x.jpg
// module id = 1515
// module chunks = 40